const showTurnstileError = function(form, message) {
    const errorContainer = form.querySelector('.turnstile-search-error');
    if (errorContainer) errorContainer.textContent = message;
};

const verifyTurnstileProtectedForm = async function(form, tokenOverride) {
    if (!form || form.dataset.turnstileSubmitting === 'true' || form.dataset.turnstileRedirectInProgress === 'true') return false;

    const responseField = form.querySelector('input[name="cf-turnstile-response"]');
    const token = tokenOverride || responseField?.value;
    if (!token) {
        showTurnstileError(form, 'Please complete the security check.');
        return false;
    }

    form.dataset.turnstileSubmitting = 'true';
    showTurnstileError(form, '');

    const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
    submitButtons.forEach((button) => {
        button.disabled = true;
    });

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    try {
        const response = await fetch(form.dataset.turnstileVerifyPath, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
                'Accept': 'application/json'
            },
            body: JSON.stringify({ response: token })
        });

        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            showTurnstileError(form, body.error || 'Please refresh the page and try the security check again.');
            return false;
        }

        if (form.dataset.turnstileRedirectTo) {
            form.dataset.turnstileRedirectInProgress = 'true';
            window.location.assign(form.dataset.turnstileRedirectTo);
        }

        return true;
    } catch (_error) {
        showTurnstileError(form, 'Please refresh the page and try the security check again.');
        return false;
    } finally {
        if (form.dataset.turnstileRedirectInProgress !== 'true') {
            form.dataset.turnstileSubmitting = 'false';

            submitButtons.forEach((button) => {
                button.disabled = false;
            });
        }
    }
};

window.turnstileSearchAutoSubmit = function(token) {
    const form = document.querySelector('form[data-turnstile-protected="true"]');
    if (!form) return;

    void verifyTurnstileProtectedForm(form, token);
};

export const setupTurnstileProtectedForms = function() {
    document.querySelectorAll('form[data-turnstile-protected="true"]').forEach(function(form) {
        if (form.dataset.turnstileInitialized === 'true') return;

        form.dataset.turnstileInitialized = 'true';

        form.addEventListener('submit', async function(event) {
            event.preventDefault();
            await verifyTurnstileProtectedForm(form);
        });
    });
};
